export default {
	appName: 'Idicare',
	apiURL: 'https://pt.idicare.com/api/',
	// apiURL: 'http://localhost:8080',
	stripePK: 'pk_test_65BVP6J1Qwl3eInDHgYzyodW',
	googleMapsKey: 'AIzaSyAbqenzl3ZKNJY6fOEy9CvBicWW_Ts9ltQ',
	googleMapsLibraries: ['places', 'drawing'],
	defaultLang: 'en-gb'
}



// WEBPACK FOOTER //
// ./src/settings/index.js